import { render, staticRenderFns } from "./SegmentedPickerTabs.vue?vue&type=template&id=c660fad2"
import script from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedPickerTabs.vue?vue&type=style&index=0&id=c660fad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports